import React, { useEffect } from "react";
import "../Css/CommunityOutreach.css";
import APDAWalk from "../Assets/APDA-Walk.jpeg";
import SeniorFlyer from "../Assets/SportsForEquity-Senior-Flyer-May2026.jpeg";
import DublinFlyer from "../Assets/Dublin-Camp-Flyer-April2026.jpeg";
import DublinSummerFlyer from "../Assets/Dublin-CA-Summer-2026.jpeg";
import VTSevaFlyer from "../Assets/Sai-Camp-Flyer-Aug2025.jpeg";
import NorthWestParkinson from "../Assets/NorthWestParkinson.jpeg";
import NWPFOutReach from "../Assets/NWPFOutReach.jpeg";
import TournamentFlyer from "../Assets/SportsForEquity-Tournament-Flyer-Aug2026.jpeg";
import TriValleyOngoingClasses from "../Assets/Tri-Valley-Ongoing-Classes.jpeg";


const APDA_URL = "https://secure.qgiv.com/event/2026-parkinsons-walk-apda-seattle-wa/team/1035134/";
const NWPF_URL = "https://nwpf.donordrive.com/teams/5169";

const events = [
  {
    img: SeniorFlyer,
    badge: "Ongoing",
    badgeClass: "co-badge-ongoing",
    title: "Table Tennis for Health Equity & Community Wellness",
    location: "SPTTC — Bellevue, WA",
    schedule: "Every Other Saturday • 9:00 AM – 10:30 AM",
    description:
      "SportsForEquity’s Seattle chapter hosts biweekly sessions for the Parkinson’s community. These sessions welcome all ability levels, and beginners are highly encouraged to join. No sign-up is required—just show up! To learn more, contact info@sportsforequity.live.",
  },
  {
    img: TriValleyOngoingClasses,
    badge: "Ongoing",
    badgeClass: "co-badge-ongoing",
    title: "Table Tennis for Health Equity & Community Wellness",
    location: "Micromotion Table Tennis Academy — Pleasanton, CA",
    schedule: "Every Sunday • 2:30 PM – 4:00 PM (1.5 Hours)",
    description:
      "SportsForEquity's Tri-Valley chapter hosts weekly table tennis sessions for boys and girls ages 5 – 15, led by passionate young coaches and table tennis enthusiasts. All skill levels are welcome — whether your child is a beginner or looking to take their game to the next level, this is the perfect place to learn, improve, make friends, and have fun. Spaces are limited. Drop-in is $30 per session, or $100 per person monthly; loaner paddles are available. 100% of proceeds support Health Equity Pillar. To register, text or WhatsApp 408-466-7567 or 408-585-8876, or email sfe.trivalley@gmail.com.",
  },
  {
    img: TournamentFlyer,
    badge: "Past Event",
    badgeClass: "co-badge-past",
    title: "PingPongParkinson Tournament — SportsForEquity Tournament for Health Equity and Community Wellness",
    location: "SPTTC — Bellevue, 13249 NE 20th St, Bellevue, WA 98005",
    schedule: "Saturday, Aug 15, 2026 • 9:00 AM – Noon",
    description:
      "Join us for our annual PingPongParkinson tournament, 2026, a lively event designed to bring our community together through movement, teamwork, and fun. Whether you're a beginner or a seasoned player, this friendly competition is all about celebrating wellness and connection. Everyone is welcome.",
  },
  {
    img: DublinSummerFlyer,
    badge: "Past Event",
    badgeClass: "co-badge-past",
    title: "Ping Pong Summer Camp — Tri-Valley, CA",
    location: "MicroMotion Table Tennis Academy — Pleasanton, CA",
    schedule: "August 3 – 7, 2026 • 5:30 PM – 7:30 PM (Mon–Fri)",
    description:
      "A five-day summer camp for kids ages 5 – 15, organized by the incoming sophomores of Emerald High School and founders of the Tri-Valley chapter. Across the week, campers learn and play through the fundamentals of table tennis while building focus, coordination, confidence, and teamwork through fun games and activities. Loaner paddles are available for anyone who needs one. Early-bird registration is $100 (before July 15, 2026) and $120 afterward, and spots are limited.",
  },
  {
    img: DublinFlyer,
    badge: "Past Event",
    badgeClass: "co-badge-past",
    title: "Ping Pong Spring Break Camp — Tri-Valley, CA",
    location: "Tri-Valley, CA",
    schedule: "April 8 – 10, 2026 • 3:00 PM – 5:00 PM (Wed–Fri)",
    description:
      "A three-day spring break camp for kids ages 5 – 15, organized by Amritshyaam and Raghav Shah of the SportsForEquity Tri-Valley chapter. Both are competitive high-school table tennis players who have won national, state, and local tournaments. The camp covered the fundamentals of table tennis along with life skills like agility, hand-eye coordination, and faster reaction times — all wrapped up in fun games and prizes.",
  },
  {
    img: VTSevaFlyer,
    badge: "Past Event",
    badgeClass: "co-badge-past",
    title: "Table Tennis for a Cause",
    location: "Sammamish, WA",
    schedule: "August 11 – 15, 2025 • 1:00 PM – 6:00 PM",
    description:
      "Hosted by SportsForEquity.",
  },
];

const CommunityOutreach = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Community Outreach | SportsForEquity";

    let metaDescription = document.querySelector('meta[name="description"]');
    let createdMeta = false;
    const prevDescription = metaDescription ? metaDescription.getAttribute("content") : null;

    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
      createdMeta = true;
    }
    metaDescription.setAttribute(
      "content",
      "SportsForEquity is a youth-led organization using table tennis to expand access to neuro-wellness and health equity, in partnership with the PingPongParkinson® Washington Chapter and the American Parkinson Disease Association Northwest Chapter."
    );

    return () => {
      document.title = prevTitle;
      if (createdMeta) {
        metaDescription.remove();
      } else if (prevDescription !== null) {
        metaDescription.setAttribute("content", prevDescription);
      }
    };
  }, []);

  return (
    <div className="co-page">

      {/* ── Hero ─────────────────────────────────────────────── */}
      <section className="co-hero">
        <h1 className="co-title">Community Outreach</h1>
        <p className="co-tagline">
          SportsForEquity expands access to neuro‑health and health equity through table‑tennis–based movement programs. In collaboration with community partners—including the PingPongParkinson® Washington Chapter and the American Parkinson Disease Association (APDA) Northwest Chapter—we deliver inclusive, research‑informed neuro‑wellness sessions. Our outreach spans specialized Parkinson’s Neuro-Wellness Sessions, community group visits, hands‑on workshops, conferences, and exhibitor events that bring movement, awareness, and connection directly to the people who benefit most.
Beyond neuro‑wellness, we lead ongoing fundraising efforts to strengthen equitable access to healthcare. At the same time, we train youth athletes to become confident leaders who volunteer, coach, and serve—ensuring the next generation is fully equipped to advance health equity and neuro‑fitness through table tennis.
        </p>
      </section>

      {/* ── All Feature Cards + Events in one section for consistent gap ── */}
      <section className="co-events">

        {/* NWPF Partnership — Ping Pong Parkinson */}
        <article className="co-event-card">
          <div className="co-event-flyer">
            <img
              src={NWPFOutReach}
              alt="SportsForEquity partnered with Northwest Parkinson's Foundation — Table Tennis Ping Pong Parkinson"
              className="co-flyer-img"
            />
          </div>
          <div className="co-event-body">
            <h2 className="co-event-title">SportsForEquity Partnered with NorthWest Parkinson's Foundation</h2>
            <p className="co-event-description">
              SportsForEquity has partnered with the Northwest Parkinson's Foundation to bring table tennis sessions to the Parkinson's community. Our bi-weekly sessions at Seattle Pacific Table Tennis Club in Bellevue, WA welcome participants of all ability levels — alongside their care partners and family members.
            </p>
            <a
              href="https://nwpf.org/event/ping-pong-parkinson/2026-08-01/"
              target="_blank"
              rel="noreferrer"
              className="co-download-link"
            >
              🔗 Join Us
            </a>
          </div>
        </article>

        {/* APDA Walk */}
        <article className="co-event-card">
          <div className="co-event-flyer">
            <a href={APDA_URL} target="_blank" rel="noreferrer">
              <img
                src={APDAWalk}
                alt="APDA 2026 Optimism Walk for Parkinson's — SportsForEquity Team Page"
                className="co-flyer-img"
              />
            </a>
          </div>
          <div className="co-event-body">
            <h2 className="co-event-title">Support Parkinson's Wellness in Washington</h2>
            <p className="co-event-description">
              We're proud to join the APDA Seattle Parkinson's Walk through our SportsForEquity
              team page. Every contribution helps expand accessible, movement‑based wellness
              programs for individuals and families living with Parkinson's across our region.
            </p>
            <p className="co-event-description">
              Together, we can build a healthier, more supported, and more connected Parkinson's
              community.
            </p>
            <a href={APDA_URL} target="_blank" rel="noreferrer" className="co-download-link">
              🔗 Join us
            </a>
          </div>
        </article>

        {/* NWPF */}
        <article className="co-event-card">
          <div className="co-event-flyer">
            <a href={NWPF_URL} target="_blank" rel="noreferrer">
              <img
                src={NorthWestParkinson}
                alt="Northwest Parkinson's Foundation — SportsForEquity Team Page"
                className="co-flyer-img"
              />
            </a>
          </div>
          <div className="co-event-body">
            <h2 className="co-event-title">Support Parkinson's Wellness in Washington</h2>
            <p className="co-event-description">
              We're excited to join the Northwest Parkinson's Foundation outreach community through
              our SportsForEquity team page. Every contribution helps expand accessible,
              movement‑based wellness programs and support families across our region.
            </p>
            <p className="co-event-description">
              Together, we can build a healthier, more connected Parkinson's community.
            </p>
            <a href={NWPF_URL} target="_blank" rel="noreferrer" className="co-download-link">
              🔗 Join or Support Our Team
            </a>
          </div>
        </article>

        {/* Events list */}
        {events.map((evt, i) => (
          <article className="co-event-card" key={i}>
            <div className="co-event-flyer">
              <a href={evt.img} target="_blank" rel="noreferrer">
                <img src={evt.img} alt={evt.title} className="co-flyer-img" />
              </a>
            </div>
            <div className="co-event-body">
              <span className={`co-badge ${evt.badgeClass}`}>{evt.badge}</span>
              <h2 className="co-event-title">{evt.title}</h2>
              <div className="co-event-meta">
                <div className="co-meta-row">
                  <span className="co-meta-label">When</span>
                  <span className="co-meta-value">{evt.schedule}</span>
                </div>
                <div className="co-meta-row">
                  <span className="co-meta-label">Where</span>
                  <span className="co-meta-value">{evt.location}</span>
                </div>
              </div>
              <p className="co-event-description">{evt.description}</p>

            </div>
          </article>
        ))}

      </section>

    </div>
  );
};

export default CommunityOutreach;